import { Component, OnInit, OnChanges, inject } from '@angular/core';
import {
  Price,
  ProductService,
  PriceService,
  AvailabilityService,
  SelectedCustomerService,
  CartService,
  CartRow,
  Availability,
  Product,
  CartRowPrice,
  AuthService
} from 'gung-standard';
import { Subscription, forkJoin, of } from 'rxjs';
import { ListItemRendererComponent } from 'gung-list';
import { first, map } from 'rxjs';

@Component({
    selector: 'colmec-sales-cart-list',
    templateUrl: './colmec-sales-cart-list.component.html',
    styleUrls: ['./colmec-sales-cart-list.component.scss'],
    standalone: false
})
export class ColmecSalesCartListComponent extends ListItemRendererComponent<CartRow[]> implements OnInit, OnChanges {  protected productService = inject(ProductService);
  protected priceService = inject(PriceService);
  protected availabilityService = inject(AvailabilityService);
  protected selectedCustomerService = inject(SelectedCustomerService);
  protected authService = inject(AuthService);

  protected cachedData: { [id: string]: { product: Product; price: CartRowPrice; availability: Availability } } = {};
  private subscriptions: Subscription[] = [];
  public roles: string[];
  public isAdmin: boolean;
  public isCreditBlocked: boolean;

  ngOnInit() {
    this.updateData();
    this.selectedCustomerService.getSelectedCustomer().subscribe((selecedCustoer) =>
      this.isCreditBlocked = selecedCustoer.extra.kus.kreditsparr
    );
  }

  ngOnChanges() {
    this.updateData();
  }

  updateData() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
    const ids = this.data.map(c => c.productId);
    const cachedIds = Object.keys(this.cachedData);
    const toGetIds = ids.filter(id => !cachedIds.includes(id));

    const sub = forkJoin({
      cartRows: of(this.data),
      roles: this.authService.getRoles().pipe(first()),
      products: this.productService.getProductsByIds(toGetIds),
      prices: this.priceService.getCartRowPricesObservable(this.data).pipe(first()),
      availabilities: this.availabilityService
        .getAvailabilities(toGetIds, undefined, true)
        .pipe(map(avs => avs.map(av => ({ ...av, availabilities: av.extra.availabilities }))))
    }).subscribe(resp => {
      // update cached data with new rows
      this.roles = resp.roles;
      this.isAdmin = this.roles.indexOf('ADMIN') >= 0;
      this.cachedData = {
        ...this.cachedData,
        ...toGetIds
          .map(id => ({
            product: resp.products.find(p => p.id === id),
            price: resp.prices.find(p => p.productId === id),
            availability: resp.availabilities.find(av => av.productId === id)
          }))
          .reduce((acc, curr) => ({ ...acc, [curr.product.id]: curr }), {})
      };
      // update cached data with new row prices
      resp.prices.forEach(price => (this.cachedData[price.productId].price = price));
    });
    this.subscriptions.push(sub);
  }

  public trackByFn(index: number, item: CartRow) {
    return item.productId + '_' + item.productPartialId;
  }

  calculateTotalValueWithoutDiscounts(): Price {
    if (Object.keys(this.cachedData).length === 0) {
      return {
        value: 0,
        currencyCode: ''
      };
    }

    /*if (this.cachedData === {}) {
      return {
        value: 0,
        currencyCode: ''
      };
    }*/

    const value = Object.values(this.cachedData)
      .map(r => r.price.cartRowTotalPrice.value)
      .reduce((acc, curr) => acc + curr, 0);
    const currencyCode = Object.values(this.cachedData)[0].price.cartRowTotalPrice.currencyCode;
    return {
      value,
      currencyCode
    };
  }

  calculateTotalValueWithDiscounts(): Price {
    if (Object.keys(this.cachedData).length === 0) {
      return {
        value: 0,
        currencyCode: ''
      };
    }

    /*if (this.cachedData === {}) {
      return {
        value: 0,
        currencyCode: ''
      };
    }*/

    const value = Object.values(this.cachedData)
      .map(r => r.price.cartRowTotalPriceInclRowDiscount.value)
      .reduce((acc, curr) => acc + curr, 0);
    const currencyCode = Object.values(this.cachedData)[0].price.cartRowTotalPriceInclRowDiscount.currencyCode;
    return {
      value,
      currencyCode
    };
  }
}
